module.exports = __webpack_public_path__ + "static/media/zing-certified.50c15df3.png";